import React, {useState} from 'react';
import styles from './styles';
import ImageUpload from './ImageUpload';
import ContactsUpload from './ContactsUpload';
import {Button, Animation} from '@xpertdox_js/xdcomponents';
import TrialSearch from './TrialSearch';
import Assets from './Assets';
import SelectedTrials from './SelectedTrials';
import { useLogHandlerDispatch } from '../../../../Context/LogHandlerContext'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'

const UploadsSection = props => {

  const [tab, setTab] = useState(null);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  const { updateLogHandler } = useLogHandlerDispatch()

  const btnStyles = {
    ...styles.button,
  }

  const activeBtnStyles = {
    ...styles.button,
    ...styles.buttonActive,
  }

  const handleActivityLogUpdate = (_id) => {
    updateLogHandler({
      type: 'activity_log',
      body: {
        _id,
        timestamp: Date.now(),
        instance: contextInstance || user.instance
        // user
      }
    })
  }

  const handleContactsUpload = e => {
    setTab(null);
    props.uploadContacts(e);
    handleActivityLogUpdate(`UploadsSection.handleContactsUpload`)
  }

  const addTrial = trialInfo => {
    let update = props.selectedTrials.slice();
    let check = update.map(trial => trial._id);
    if (!check.includes(trialInfo._id)) {
      update.push(trialInfo);
      props.setSelectedTrials(update);
    }
    handleActivityLogUpdate(`UploadsSection.addTrial`)
  }

  const removeTrial = trialId => {
    props.setSelectedTrials(props.selectedTrials.filter(trial => trial._id !== trialId))
    handleActivityLogUpdate(`UploadsSection.removeTrial`)
  }

  return(
    <React.Fragment>
    <div style={styles.container}>
      <Button
        onClick={() => props.setShowContacts(!props.showContacts)}
        styles={props.showContacts ? activeBtnStyles : btnStyles}
        hoverStyles={props.showContacts ? null : styles.buttonHov}
        title='Show Contacts'
      >
        <div style={styles.buttonContent}>
        <svg style={styles.btnSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M349.1 334.7c-11.2-4-29.5-4.2-37.6-7.3-5.6-2.2-14.5-4.6-17.4-8.1-2.9-3.5-2.9-28.5-2.9-28.5s7-6.6 9.9-14c2.9-7.3 4.8-27.5 4.8-27.5s6.6 2.8 9.2-10.4c2.2-11.4 6.4-17.4 5.3-25.8-1.2-8.4-5.8-6.4-5.8-6.4s5.8-8.5 5.8-37.4c0-29.8-22.5-59.1-64.6-59.1-42 0-64.7 29.4-64.7 59.1 0 28.9 5.7 37.4 5.7 37.4s-4.7-2-5.8 6.4c-1.2 8.4 3 14.4 5.3 25.8 2.6 13.3 9.2 10.4 9.2 10.4s1.9 20.1 4.8 27.5c2.9 7.4 9.9 14 9.9 14s0 25-2.9 28.5-11.8 5.9-17.4 8c-8 3.1-26.3 3.5-37.6 7.5-11.2 4-45.8 22.2-45.8 67.2h278.3c.1-45.1-34.5-63.3-45.7-67.3z"/><path d="M140 286s23.9-.8 33.4-9.3c-15.5-23.5-7.1-50.9-10.3-76.5-3.2-25.5-17.7-40.8-46.7-40.8h-.4c-28 0-43.1 15.2-46.3 40.8-3.2 25.5 5.7 56-10.2 76.5C69 285.3 93 285 93 285s1 14.4-1 16.8c-2 2.4-7.9 4.7-12 5.5-8.8 1.9-18.1 4.5-25.9 7.2-7.8 2.7-22.6 17.2-22.6 37.2h80.3c2.2-8 17.3-22.3 32-29.8 9-4.6 17.9-4.3 24.7-5.2 0 0 3.8-6-8.7-8.3 0 0-17.2-4.3-19.2-6.7-1.9-2.2-.6-15.7-.6-15.7zM372 286s-23.9-.8-33.4-9.3c15.5-23.5 7.1-50.9 10.3-76.5 3.2-25.5 17.7-40.8 46.7-40.8h.4c28 0 43.1 15.2 46.3 40.8 3.2 25.5-5.7 56 10.2 76.5-9.5 8.6-33.5 8.3-33.5 8.3s-1 14.4 1 16.8c2 2.4 7.9 4.7 12 5.5 8.8 1.9 18.1 4.5 25.9 7.2 7.8 2.7 22.6 17.2 22.6 37.2h-80.3c-2.2-8-17.3-22.3-32-29.8-9-4.6-17.9-4.3-24.7-5.2 0 0-3.8-6 8.7-8.3 0 0 17.2-4.3 19.2-6.7 1.9-2.2.6-15.7.6-15.7z"/></svg>
        <span style={styles.count}>{props.count}</span>
        </div>
      </Button>
      <Button
        onClick={() => setTab(tab === 'contacts' ? null : 'contacts')}
        styles={tab === 'contacts' ? activeBtnStyles : btnStyles}
        hoverStyles={tab === 'contacts' ? null : styles.buttonHov}
        title='Upload Contacts Csv'
      >
        <div style={styles.buttonContent}>
        <svg style={styles.btnSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M385.3 386c-15.6-5.5-37.8-6.8-52.1-10-8.2-1.8-20.1-6.3-24.1-11.1-3.5-4.2-2.1-38.4-1.7-47.2.1-1.3.5-2.6 1.1-3.8 2.2-3.6 7.2-12.2 10.3-20 3-7.6 6.2-25 7.6-33.3.4-2.4 1.9-4.5 4-5.6 2.6-1.5 6.1-4.9 7.8-13.4 3.1-15.7 8-21.8 7.4-33.5-.3-5.2-1.7-8-3.2-9.5-2-1.9-2.7-4.8-2-7.4 1.9-7.6 4.7-22.6 5.2-45.6.9-41.1-31.3-81.6-89.5-81.6-59.1 0-90.5 40.5-89.6 81.6.5 23 3.3 38 5.1 45.6.6 2.7-.1 5.5-2 7.4-1.5 1.5-3 4.3-3.2 9.5-.6 11.7 4.3 17.8 7.4 33.5 1.7 8.4 5.2 11.9 7.8 13.4 2.1 1.2 3.6 3.2 4 5.6 1.4 8.3 4.6 25.7 7.6 33.3 3.1 7.8 8.2 16.5 10.3 20 .7 1.1 1.1 2.4 1.1 3.8.4 8.8 1.8 43.1-1.7 47.2-4 4.8-15.9 9.3-24.1 11.1-14.3 3.2-36.5 4.5-52.1 10-14.2 5-55.3 20.5-62.5 52.3-1.1 5 2.7 9.7 7.9 9.7H440c5.1 0 8.9-4.7 7.8-9.7-7.2-31.8-48.3-47.3-62.5-52.3z"/><path d="M437.5 293.5h-27v-27c0-5.8-4.7-10.5-10.5-10.5s-10.5 4.7-10.5 10.5v27h-27c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5h27v27c0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5v-27h27c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5z"/></svg>
        </div>
      </Button>
      <Button
        onClick={() => setTab(tab === 'flyers' ? null : 'flyers')}
        styles={tab === 'flyers' ? activeBtnStyles : btnStyles}
        hoverStyles={tab === 'flyers' ? null : styles.buttonHov}
        title='Upload Media'
      >
        <div style={styles.buttonContent}>
        <svg style={styles.btnSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M262.3 199.2c-1.6-2.8-5.6-3.2-7.7-.7l-91.9 122.2c-2.5 2.9-.6 7.4 3.2 7.7l161.1 14c3.8.3 6.4-3.8 4.5-7.1l-69.2-136.1zM367.2 264.1c-1.6-2.8-5.6-3.2-7.7-.7l-24.8 25.1a4.68 4.68 0 0 0-.5 5.4l25.4 49.5c.8 1.3 2.1 2.2 3.7 2.3l44.9 3.9c3.8.3 6.4-3.8 4.5-7.1l-45.5-78.4zM378.1 224.4c11.2-.1 20.9-8.3 23-19.2 2.8-14.8-8.6-28.3-23.7-28.1-11.2.1-20.9 8.3-23 19.2-2.8 14.8 8.6 28.3 23.7 28.1z"/><path d="M455.2 129.3l-65.8-5.7-6.1-67c-1.3-14.9-14.5-25.9-29.5-24.5L56.7 58.9c-14.9 1.3-25.9 14.5-24.6 29.4l26.8 296.5c1.3 14.9 14.5 25.9 29.5 24.5l15.7-1.4-1.5 16.7c-1.3 14.9 9.7 28 24.7 29.3l297.3 25.9c14.9 1.3 28.1-9.7 29.4-24.6l26-296.6c1.2-14.8-9.8-28-24.8-29.3zM87.6 300.7c-3.7.3-7-2.4-7.4-6.1l-18-200c-.3-3.7 2.4-7 6.1-7.3l279.2-25.1c3.7-.3 7 2.4 7.4 6.1l4.8 52.8L158 103.4c-14.9-1.3-28.1 9.7-29.4 24.6l-14.9 170.3-26.1 2.4zm362.2-135.6l-17.5 200c-.3 3.7-3.6 6.5-7.3 6.2l-18.6-1.6L145.7 347c-3.7-.3-6.5-3.6-6.2-7.3l3.8-43.9L157 139.7c.3-3.7 3.6-6.5 7.3-6.2l198 17.3 29.7 2.6 51.6 4.5c3.8.2 6.6 3.5 6.2 7.2z"/></svg>
        </div>
      </Button>
      <Button
        onClick={() => setTab(tab === 'trials' ? null : 'trials')}
        styles={tab === 'trials' ? activeBtnStyles : btnStyles}
        hoverStyles={tab === 'trials' ? null : styles.buttonHov}
        title='Add Trial Info'
      >
        <div style={styles.buttonContent}>
        <svg style={styles.btnSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M140.5 160v240c0 8.8 7.2 16 16 16h200c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16h-200c-8.8 0-16 7.2-16 16zM321.5 81h-17c0-5.6-1-11-2.7-16-2.1-6-5.3-11.4-9.4-16-8.8-9.9-21.6-17-35.9-17s-27.1 7.1-35.9 17c-4.1 4.6-7.3 10-9.4 16-1.7 5-2.7 10.4-2.7 16H194c-9.6 0-17.5 7.9-17.5 17.5V114c0 1.1.9 2 2 2h156c1.1 0 2-.9 2-2V96c0-8.3-6.7-15-15-15zm-62.9 15.5c-10.5 1.3-19.3-7.5-17.9-17.9.9-7.1 6.7-12.9 13.8-13.8 10.5-1.3 19.3 7.5 17.9 17.9-.9 7.2-6.7 12.9-13.8 13.8z"/><path d="M400 48h-75.2c-1.7 0-2.6 1.9-1.6 3.2 2.9 3.9 5.3 8.1 7 12.8.3.8 1 1.3 1.9 1.3h.5c18.7 0 26.9 14.9 27.5 33.5V114c0 1.1.9 2 2 2h20.3c8.8 0 16 7.2 16 16v297.4c0 8.8-7.2 16-16 16h-253c-8.8 0-16-7.2-16-16V132c0-8.8 7.2-16 16-16h21.3c1.1 0 2-.9 2-2v-8.8c0-19.1 5.6-36.7 27.6-36.7h.3c.9 0 1.8-.6 1.9-1.6 1.5-6.9 4.1-11.7 7.2-15.8 1-1.3.1-3.2-1.6-3.2l-76.3-.1C94.3 47.9 80 62.1 80 79.7V424c0 41.7 14.3 56 32 56h288.5c17.4 0 31.5-14.1 31.5-31.5V80c0-17.7-14.3-32-32-32z"/></svg>
        </div>
      </Button>
      {tab !== null &&
        <Animation
          animation={[
            ['opacity', {0: 0, 100: 1}, 180],
            ['transform', {0: 100, 80: -4, 100: -1}, 320, {easing: 'easeOut', valueMap: 'translateY($vpx)'}]
          ]}
          wrapStyles={styles.content}
        >
          {tab === 'trials' &&
            <React.Fragment>
              <TrialSearch
                addTrial={addTrial}
                selectedTrials={props.selectedTrials}
                removeTrial={removeTrial}
              />
              {props.selectedTrials && props.selectedTrials.length > 0 &&
                <SelectedTrials
                  removeTrial={removeTrial}
                  selectedTrials={props.selectedTrials}
                />
              }
            </React.Fragment>
          }
          {tab === 'contacts' &&
            <ContactsUpload
              uploadContacts={handleContactsUpload}
            />
          }
          {tab === 'flyers' &&
            <React.Fragment>
              <ImageUpload
                addAsset={props.addAsset}
                clearTabs={() => setTab(null)}
                removeAsset={props.removeAsset}
              />
            {props.assets.length > 0 &&
                <Assets
                  assets={props.assets}
                  removeAsset={props.removeAsset}
                />
              }
            </React.Fragment>
          }
        </Animation>
      }
      </div>
      {props.assets.length > 0 &&
        <div style={styles.inlineAssets}>
          <Assets
            assets={props.assets}
            removeAsset={props.removeAsset}
          />
        </div>
      }
    </React.Fragment>
  )
}

export default UploadsSection;
